// extracted by mini-css-extract-plugin
export default {"root":"agriculture-hint-paramaters_root__WKspN"};